import React from 'react';
import logoWhite from '../assets/karbon360-logo-white.png';

/**
 * The left-hand brand panel shared by every auth screen (login, register,
 * forgot/reset password).
 *
 * This used to be copy-pasted per screen, and the copies drifted: login got the
 * real wordmark and the current positioning, while register and the password
 * screens were left on a hand-drawn SVG approximation of the logo and the old
 * tagline. Testers hit /register and saw a different product than the one on
 * the login page. One component, one panel — keep it that way.
 */
export function AuthBranding() {
  return (
    <div className="login-left">
      <div className="branding">
        <img src={logoWhite} alt="Karbon360°" className="brand-wordmark" />
        <div className="brand-kicker">Carbon &amp; ESG accounting</div>
        <h1>Locally-accurate carbon reporting</h1>
        <p>Track, manage and report your carbon footprint with Kosovo-specific emission factors.</p>
        <div className="brand-chips">
          <span><i />GHG Protocol · Corporate Standard</span>
          <span><i />ISO 14064-1:2018</span>
          <span><i />CBAM-ready reporting</span>
        </div>
      </div>
    </div>
  );
}

export default AuthBranding;
